import { Flow_0_0_2 } from '@flexus/core';

export const BET_37: Flow_0_0_2 = {
	id: '37',
	name: 'TL_onsite',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for team leader to assess job'
		}
	},
	startNode: '',
	nodes: {}
};
